var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.getSrc()
    ? _c(
        "div",
        {
          staticClass: "sc-message--text",
          style: Object.assign({}, _vm.messageColors, _vm.extendedStyle || {}),
          attrs: { id: "assetMessage" },
        },
        [
          _vm.isGroupMessage
            ? _c(
                "span",
                {
                  staticClass: "whatsapp-number-first",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      _vm.showWhatsappChatStarterModal = true
                    },
                  },
                },
                [
                  _c(
                    "a",
                    {
                      style: { color: _vm.getWhatsappNumberColor() },
                      attrs: { href: "javascript:void(0)" },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.whatsappAuthorName) +
                          " - " +
                          _vm._s(_vm.whatsappAuthorNumber)
                      ),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "media-content-wrapper" }, [
            _c(
              "a",
              {
                directives: [
                  {
                    name: "tippy",
                    rawName: "v-tippy",
                    value: { followCursor: true, placement: "bottom-end" },
                    expression:
                      "{ followCursor: true, placement: 'bottom-end' }",
                  },
                ],
                attrs: {
                  href: _vm.getSrc(),
                  download: "",
                  target: "_blank",
                  content: _vm.$t("message.download"),
                },
              },
              [
                _vm.getExt()
                  ? _c(
                      "div",
                      { staticClass: "fi", class: "fi-" + _vm.getExt() },
                      [
                        !_vm.isFilterAsset
                          ? _c("div", { staticClass: "fi-content" }, [
                              _vm._v(_vm._s(_vm.getExt())),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isFilterAsset
                          ? _c("div", { staticClass: "fi-content" }, [
                              _c("div", { attrs: { id: "fi-data" } }, [
                                _c("p", [
                                  _vm._v(
                                    _vm._s(_vm.$t("message.type")) +
                                      " : " +
                                      _vm._s(_vm.getExt())
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    _vm._s(_vm.$t("message.sender")) +
                                      " : " +
                                      _vm._s(
                                        !!_vm.message.raw
                                          ? _vm.message.raw.user.name
                                          : ""
                                      )
                                  ),
                                ]),
                              ]),
                            ])
                          : _vm._e(),
                      ]
                    )
                  : _c("a-icon", { attrs: { type: "cloud-download" } }),
                _c("p", { staticClass: "asset-text mt-4" }, [
                  _vm._v(_vm._s(_vm.getAssetName())),
                ]),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _vm.isGroupMessage
            ? _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "row",
                    "justify-content": "end",
                    "align-items": "center",
                    padding: "0 0.3rem",
                  },
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "sc-message-meta-new whatsapp-number",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          _vm.showWhatsappChatStarterModal = true
                        },
                      },
                    },
                    [
                      _c(
                        "a",
                        {
                          style: { color: _vm.getWhatsappNumberColor() },
                          attrs: { href: "javascript:void(0)" },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.whatsappAuthorName) +
                              " - " +
                              _vm._s(_vm.whatsappAuthorNumber)
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.message.isMail && _vm.message.data.meta
            ? _c(
                "span",
                {
                  staticClass: "sc-message--meta",
                  class: _vm.message.author === "me" ? "received" : "sent",
                },
                [_vm._v(_vm._s(_vm.message.data.meta))]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showWhatsappChatStarterModal
            ? _c(
                "Modal2",
                {
                  attrs: {
                    title: _vm.$t("message.whatsappChatStart"),
                    showFooter: false,
                  },
                  on: {
                    cancel: function ($event) {
                      _vm.showWhatsappChatStarterModal = false
                    },
                  },
                },
                [
                  _c("WhatsappChatStarter", {
                    attrs: {
                      "default-phone-number": _vm.whatsappAuthorNumber,
                      "channel-override": "",
                      "phone-number-override": "",
                      "default-name": _vm.whatsappAuthorName,
                    },
                    on: {
                      close: function ($event) {
                        _vm.showWhatsappChatStarterModal = false
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }